"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ModalFooter = exports.FooterButton = void 0;
var _CloseCircleFill = _interopRequireDefault(require("@zenlayer/zen-design-icons/assets/suggest/CloseCircleFill.svg"));
var _react = _interopRequireWildcard(require("react"));
var _icon = _interopRequireDefault(require("../icon"));
var _button = _interopRequireDefault(require("../button"));
var _elevation = _interopRequireDefault(require("../elevation"));
var _classnames = _interopRequireDefault(require("classnames"));
var _ahooks = require("ahooks");
var _useConfig = require("../hooks/useConfig");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ModalFooter = props => {
  const {
    children,
    className,
    style
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_elevation.default, {
    type: 5,
    shadow: false,
    className: (0, _classnames.default)('modal-footer', className),
    style: style,
    children: children
  });
};
exports.ModalFooter = ModalFooter;
const FooterButton = exports.FooterButton = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const {
    locale: {
      Modal: ModalLocale
    }
  } = (0, _useConfig.useConfig)();
  const {
    cancelButtonText = ModalLocale.cancel,
    okButtonText = ModalLocale.confirm,
    onOk,
    onCancel,
    cancelButtonProps,
    okButtonProps,
    className
  } = props;
  const [okButtonLoading, setOkButtonLoading] = (0, _react.useState)(false);
  const handleOk = (0, _ahooks.useLockFn)(async () => {
    if (onOk) {
      setOkButtonLoading(true);
      const flag = await onOk();
      !!flag && (onCancel === null || onCancel === void 0 ? void 0 : onCancel());
      setOkButtonLoading(false);
    } else {
      onCancel === null || onCancel === void 0 || onCancel();
    }
  });
  (0, _react.useImperativeHandle)(ref, () => ({
    okButtonLoading,
    onCancel
  }), [okButtonLoading, onCancel]);
  return cancelButtonText !== null || okButtonText !== null ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames.default)('button-group', className, {
      ['column-2']: cancelButtonText !== null && okButtonText !== null
    }),
    children: [cancelButtonText !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      type: "normal",
      disabled: okButtonLoading,
      onClick: () => {
        onCancel === null || onCancel === void 0 || onCancel();
      },
      ...cancelButtonProps,
      children: cancelButtonText
    }), okButtonText !== null && /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
      loading: okButtonLoading,
      onClick: handleOk,
      ...okButtonProps,
      children: okButtonText
    })]
  }) : null;
});
const ModalRender = props => {
  var _footerButtonRef$curr;
  const {
    title,
    subTitle,
    closable,
    okButtonText,
    okButtonProps,
    onOk,
    cancelButtonText,
    cancelButtonProps,
    onCancel,
    footer,
    content,
    extra,
    onClose,
    contentWrapClassName
  } = props;
  const {
    locale: {
      Modal: ModalLocale
    }
  } = (0, _useConfig.useConfig)();
  const footerButtonRef = (0, _react.useRef)(null);
  const [onReset, setOnReset] = (0, _react.useState)();
  const [resetDisabled, setResetDisabled] = (0, _react.useState)(true);
  const contentDom = (0, _react.useMemo)(() => {
    return typeof content === 'function' ? content({
      setOnReset: onReset => {
        setOnReset(() => onReset);
      },
      setResetDisabled
    }) : content;
  }, [content]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _classnames.default)(contentWrapClassName, 'content-wrap'),
    children: [(title || closable) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "header",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "header-l",
        children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "title",
          children: title
        }), subTitle && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "subTitle",
          children: subTitle
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "header-r",
        children: [extra && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "extra",
          children: extra
        }), !!onReset && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "reset",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_button.default, {
            size: "s",
            type: "normal",
            onClick: () => {
              onReset === null || onReset === void 0 || onReset();
            },
            disabled: resetDisabled,
            children: ModalLocale.reset
          })
        }), closable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_icon.default, {
          type: "suggest/CloseCircleFill",
          className: (0, _classnames.default)('closeIcon', {
            'closeIcon-disabled': (_footerButtonRef$curr = footerButtonRef.current) === null || _footerButtonRef$curr === void 0 ? void 0 : _footerButtonRef$curr.okButtonLoading
          }),
          onClick: () => {
            var _footerButtonRef$curr2;
            if (!((_footerButtonRef$curr2 = footerButtonRef.current) !== null && _footerButtonRef$curr2 !== void 0 && _footerButtonRef$curr2.okButtonLoading)) {
              var _footerButtonRef$curr3, _footerButtonRef$curr4;
              (_footerButtonRef$curr3 = footerButtonRef.current) === null || _footerButtonRef$curr3 === void 0 || (_footerButtonRef$curr4 = _footerButtonRef$curr3.onCancel) === null || _footerButtonRef$curr4 === void 0 || _footerButtonRef$curr4.call(_footerButtonRef$curr3);
            }
          }
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "content",
      children: contentDom
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(FooterButton, {
      ref: footerButtonRef,
      okButtonText: okButtonText,
      okButtonProps: okButtonProps,
      onOk: onOk,
      cancelButtonText: cancelButtonText,
      cancelButtonProps: cancelButtonProps,
      onCancel: () => {
        onCancel === null || onCancel === void 0 || onCancel();
        onClose();
      },
      className: "modal-self-footerButton"
    }), footer]
  });
};
var _default = exports.default = ModalRender;